/* Svensk katalog for locale-inbox-vouchers-no.js (del 1 av 2).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'voucher.none': 'Inga verifikationer',
  'voucher.noLedgerLines': 'Inga huvudboksrader tillgängliga från backend ännu.',
  'voucher.noLedger': 'Inga huvudboksrader',
  'voucher.action': 'Åtgärd',
  'voucher.title': 'Transaktioner',
  'voucher.incompleteBasis': 'Journaltäckningen är ofullständig. Listan kan användas för dokumentuppslag men får inte läsas som en komplett huvudbok eller verifikationslista.',
  'voucher.subtitle': 'Alla bokförda transaktioner för räkenskapsåret',
  'voucher.backToVat': 'Tillbaka till MVA-meldingen',
  'voucher.showAll': 'Visa alla transaktioner',
  'voucher.download': 'Ladda ner',
  'voucher.loadingPreview': 'Laddar förhandsgranskning...',
  'voucher.cannotPreviewUse': 'Filen kan inte förhandsgranskas här. Använd Ladda ner när du vill öppna den.',
  'voucher.cannotPreview': 'Den här filtypen kan inte förhandsgranskas här.',
  'voucher.invoice': 'Faktura',
  'voucher.voucher': 'Verifikation',
  'voucher.attachmentAttached': 'Verifikation bifogad',
  'voucher.commentOptional': 'Kommentar (valfritt)',
  'voucher.commentPh': 'T.ex. felaktigt belopp, dubbelbokföring eller fel leverantör.',
  'voucher.view': 'Vy',
  'voucher.viewHelp': 'Växla mellan verifikationslista, detaljerade konteringar och huvudbok grupperad per konto.',
  'voucher.view.bilag': 'Verifikationer',
  'voucher.view.detaljer': 'Detaljer',
  'voucher.view.hovedbok': 'Huvudbok',
  'voucher.searchPh': 'Sök på verifikation, konto eller belopp',
  'voucher.searchHelp': 'Sök på verifikationsnummer, motpart, konto/kontering eller belopp. I huvudboken kan du också söka på debet, kredit och saldo.',
  'voucher.filterHelp': 'Filtrera verifikationerna på typ, bilaga, betalningsstatus, period och belopp.',
  'voucher.amountTitle': 'Belopp på verifikationen',
  'voucher.amountHelp': 'Netto är beloppet utan moms (själva kostnaden/intäkten), moms är skatten och brutto är totalbeloppet inklusive moms. Tillsammans med datum och verifikationsnummer är detta nyckeluppgifterna i bokföringen.',
  'voucher.rowHelp': 'Varje rad är en verifikation. Ikonen och etiketten visar typen (försäljning, köp, leverantörsfaktura, kreditfaktura, manuell verifikation), och du ser namn och verifikationsnummer. Tryck på raden för att öppna verifikationen.',
  'voucher.net': 'Netto',
  'voucher.netHelp': 'Beloppet utan moms - själva kostnaden eller intäkten som bokförs på konto.',
  'voucher.vat': 'Moms',
  'voucher.vatHelp': 'Mervärdesskatten på verifikationen - utgående moms på försäljning, ingående (avdragsgill) moms på köp.',
  'voucher.gross': 'Brutto',
  'voucher.grossHelp': 'Totalbeloppet inklusive moms - netto plus moms. Detta är beloppet som faktiskt betalas eller tas emot.',
  'voucher.accountPh': 'T.ex. programvara, bank eller 6300',
  'voucher.account': 'Konto',
  'voucher.accountHelp': 'Kontot anger vad bokföringen gäller - hämtat från kontoplanen. Kontonumret avgör var beloppet hamnar i bokföringen (1xxx tillgångar, 2xxx skulder/eget kapital, 3xxx intäkter, 4-7xxx kostnader). Tryck på listikonen för att söka i kontoplanen.',
  'voucher.pickAccount': 'Välj konto',
  'voucher.searchChart': 'Sök i kontoplanen...',
  'voucher.noDescription': 'Utan beskrivning',
  'voucher.removeEntry': 'Ta bort kontering',
  'voucher.entryDate': 'Verifikationsdatum',
  'voucher.entryDateHelp': 'Datumet bokföringen ska bokföras på. Det avgör vilken redovisnings- och momsperiod konteringen hamnar i.',
  'voucher.whatFor': 'Vad gäller bokföringen?',
  'voucher.whatForHelp': 'En kort text som förklarar vad bokföringen gäller. Visas i huvudboken och gör det lätt att förstå konteringen senare.',
  'voucher.fromAccount': 'Från konto',
  'voucher.toAccount': 'Till konto',
  'voucher.fromAccountCredit': 'Från konto (kredit)',
  'voucher.fromAccountHelp': 'Kontot pengarna går FRÅN - kreditsidan av bokföringen. Betalar du t.ex. hyra från bankkontot är banken (1920) ”Från”. Kredit minskar en tillgång eller ökar en skuld/intäkt.',
  'voucher.vatCode': 'Momskod',
  'voucher.vatCodeHelp': 'Momskoden styr hur moms beräknas och rapporteras i mva-meldingen. Kod 86 används för fjärrlevererbara tjänster från utlandet. Varuimport registreras via tulldeklarationen.',
  'voucher.swap': 'Byt Från och Till',
  'voucher.swapHelp': 'Byter plats på Från- och Till-kontot på raden. Användbart om du har bokfört debet och kredit åt fel håll.',
  'voucher.toAccountDebit': 'Till konto (debet)',
  'voucher.toAccountHelp': 'Kontot pengarna går TILL - debetsidan av bokföringen. Gäller bokföringen hyra är hyreskontot (6300) ”Till”. Debet ökar en kostnad eller tillgång.',
  'voucher.addLineHelp': 'Lägger till en ny bokföringsrad i den här konteringen. Använd flera rader när beloppet ska fördelas på flera konton - alla rader måste tillsammans göra att debet och kredit går jämnt ut.',
  'voucher.attachHelp': 'Bifoga dokumentation till bokföringen - kvitto, faktura eller annan verifikation. Valfritt men rekommenderat: god dokumentation gör bokföringen verifierbar. Du kan dra in filer eller klistra in en skärmbild.',
  'voucher.attachOptional': 'Bilaga (valfritt)',
  'voucher.uploadAttachment': 'Ladda upp bilaga',
  'voucher.deleteAttachment': 'Ta bort bilaga',
  'voucher.openNewTab': 'Öppna i ny flik',
  'voucher.balance': 'Balans',
  'voucher.balanceHelp': 'Visar om konteringen går jämnt ut. ”Balanserad” betyder att summa Till (debet) är lika med summa Från (kredit) - då kan bokföringen registreras. Finns det en differens måste du rätta beloppen så att de går jämnt ut.',
  'voucher.toDebit': 'Till (debet)',
  'voucher.fromCredit': 'Från (kredit)',
  'voucher.posted': 'Bokförd',
  'voucher.edit': 'Redigera',
  'voucher.newCopy': 'Ny kopia av fri kontering',
  'voucher.newFree': 'Ny fri kontering',
  'voucher.from': 'Från',
  'voucher.to': 'Till',
  'voucher.sum': 'Summa',
  'voucher.newEntry': 'Ny kontering',
  'voucher.newEntryHelp': 'Lägger till ytterligare en kontering (en ny verifikation) under samma registrering. Varje kontering har eget datum, egen beskrivning och egna rader och bokförs som en egen verifikation.',
  'voucher.postHelp': 'Bokför konteringen/konteringarna. Knappen blir aktiv först när alla konteringar är balanserade - alltså när debet och kredit går jämnt ut.',
  'voucher.details': 'Detaljer',
  'voucher.statusBalanced': 'Balanserad',
  'voucher.statusMissingAccount': 'Saknar konto',
  'voucher.statusSameAccount': 'Samma konto',
  'voucher.statusEmpty': 'Tom',
  'voucher.statusUnbalanced': 'Obalanserad',
  'voucher.attachDropHint': 'Dra och släpp filer hit, eller klistra in en skärmbild med Ctrl+V',
  'voucher.chooseBothAccounts': 'Välj både från- och tillkonto.',
  'voucher.sameAccountWarning': 'Från- och tillkonto kan inte vara samma konto.',
  'voucher.balancedReady': 'Balanserad - klar att registrera',
  'voucher.enterAmount': 'Ange ett belopp.',
  'voucher.difference': 'Differens: {amount}',
  'voucher.postedTitlePlural': 'Bokföringar registrerade',
  'voucher.postedTitleSingular': 'Bokföring registrerad',
  'voucher.postedBodyPlural': '{count} konteringar är bokförda.',
  'voucher.postedBodySingular': 'Konteringen är bokförd.',
  'voucher.postedIntro': 'Så här bokfördes det:',
  'voucher.descriptionRequired': 'Ange en beskrivning på alla konteringar innan du bokför.',
  'voucher.saveFailed': 'Kunde inte registrera bokföringen.',
  'voucher.backTo': 'Tillbaka till {label}',
  'voucher.controlPoint': 'kontrollpunkten',
  'voucher.editTitle': 'Redigera fri kontering',
  'voucher.freePosting': 'Fri kontering',
  'voucher.editSubtitle': 'Uppdatera konteringen och spara ändringarna i backend.',
  'voucher.correctPostedTitle': 'Korrigera bokförd verifikation',
  'voucher.correctPostedSubtitle': 'Originalet behålls. Plumme bokför en återföring och en ny ersättningsverifikation i en och samma åtgärd.',
  'voucher.correctPostedNotice': 'Den ursprungliga verifikationen och journalnumret ändras inte. Ändringen blir en kopplad återföring och ersättning.',
  'voucher.correctionReason': 'Orsak till korrigering',
  'voucher.correctionReasonPlaceholder': 'Beskriv vad som var fel och varför verifikationen korrigeras',
  'voucher.correctPostedAction': 'Korrigera verifikation',
  'voucher.correctionPreview': 'Förhandsgranska korrigering',
  'voucher.correctionOriginal': 'Original',
  'voucher.correctionReversal': 'Exakt återföring',
  'voucher.correctionReplacement': 'Ersättningsverifikation',
  'voucher.freePostingSubtitle': 'Manuella konteringar - debet och kredit måste gå jämnt ut',
  'voucher.freePostingTitleHelp': 'Fri kontering låter dig bokföra manuellt direkt på konto när du behöver full kontroll - till exempel rättelser, omföringar eller konteringar som inte passar i ett vanligt inköp eller en vanlig försäljning. Du styr själv vilka konton beloppet flyttas mellan.',
  'voucher.directVatWarningTitle': 'Varning: direktkontering på momskonto',
  'voucher.directVatWarningBody': 'Dessa konteringar bokförs i huvudboken men kommer inte med i MVA-meldingen. Använd vanligt inköp, försäljning eller tulldeklaration när beloppet ska rapporteras som moms.',
  'voucher.directVatExcluded': 'inte med i MVA-meldingen',
  'voucher.directVatConfirmLabel': 'Skriv OK för att bekräfta att du förstår konsekvensen',
  'voucher.directVatConfirmValue': 'OK',
  'voucher.registerEntriesPlural': 'Registrera konteringar',
  'voucher.registerEntrySingular': 'Registrera kontering',
  'voucher.registering': 'Registrerar...',
  'voucher.creditWord': 'kredit',
  'voucher.debitWord': 'debet',
  'voucher.attachmentFallbackName': 'bilaga',
  'inbox.prevPage': 'Föregående sida',
  'inbox.page': 'Sida',
  'inbox.nextPage': 'Nästa sida',
  'inbox.zoomOut': 'Zooma ut',
  'inbox.zoomIn': 'Zooma in',
  'inbox.rotate': 'Rotera verifikation',
  'inbox.mainDoc': 'Huvudverifikation',
  'inbox.moveTo': 'Flytta till',
  'inbox.payOperating': 'Driftskonto - 1920',
  'inbox.payCash': 'Kontant - 1900',
  'inbox.payPrivate': 'Privat utlägg',
  'inbox.payUnknown': 'Välj betalningskälla ...',
  'inbox.suggestion': 'Förslag från SuperPlumma',
  'inbox.docType': 'Typ av verifikation',
  'inbox.quickChoices': 'Snabbval',
  'inbox.quickChoiceUse': 'Välj vad snabbvalet ska ersätta',
  'inbox.quickChoiceRemembered': 'Ihågkommet från {count} tidigare verifikationer hos leverantören.',
  'inbox.quickChoiceAccount': 'Ersätt konto',
  'inbox.quickChoiceDescription': 'Ersätt beskrivning',
  'inbox.quickChoiceBoth': 'Ersätt båda',
  'inbox.purchase': 'Inköp',
  'inbox.supplierInvoice': 'Leverantörsfaktura',
  'inbox.pickSupplier': 'Välj leverantör',
  'inbox.invoiceNoPh': 'T.ex. 0012345',
  'inbox.toggleVatHelp': 'Tryck för att växla mellan om beloppet du anger är exklusive eller inklusive moms. Plumme räknar om automatiskt och sparar bruttobeloppet på verifikationsförslaget.',
  'inbox.vatDeductionRate': 'Föreslaget momsavdrag',
  'inbox.documentVatRateHint': 'Verifikationen visar {documentRate} % moms. Förslaget använder {deductionRate} % avdrag utifrån företagets momsstatus och vald behandling.',
  'inbox.accountCategory': 'Konto/kategori',
  'inbox.accountHelp': 'SuperPlummas förslag är förvalt. Tryck för att välja ett annat konto.',
  'inbox.dueDateFromReceipt': 'Verifikationen har inget förfallodatum. Satt till verifikationsdatum.',
  'inbox.supplierNotSaved': 'Välj en sparad leverantör, eller spara leverantören innan du bokför fakturan.',
  'err.purchase.supplierNotSaved': 'Välj en sparad leverantör, eller spara leverantören innan du bokför fakturan.',
  'inbox.duplicateTitle': 'Möjlig dubbelbokföring',
  'inbox.duplicateBody': 'En verifikation med samma datum och belopp är redan bokförd.',
  'inbox.duplicateSameSupplier': 'En verifikation med samma datum, belopp och leverantör är redan bokförd.',
  'inbox.duplicateUploadFile': 'Möjlig dubbeluppladdning: exakt samma fil finns redan i inkorgen.',
  'inbox.duplicateUploadContent': 'Möjlig dubbeluppladdning: samma leverantör och belopp som en annan verifikation i inkorgen, och verifikationsdatumen ligger inom 7 dagar.',
  'inbox.duplicateUploadCount': 'Gäller {count} andra verifikationer.',
  'inbox.setPaymentSource': 'Betalt från',
  'inbox.bulkPaymentTitle': 'Betalt från',
  'inbox.bulkPaymentLead': 'Källan anges på {count} verifikationer. Du kan ändra den på varje enskild verifikation efteråt.',
  'inbox.bulkPaymentLabel': 'Betalt från',
  'inbox.bulkPaymentHint': 'Verifikationerna blir klara för bokföring med detta konto.',
  'inbox.bulkPaymentPick': 'Välj en betalningskälla först.',
  'inbox.bulkPaymentConfirm': 'Ange på {count} verifikationer',
  'inbox.bulkPaymentDone': 'Betalningskälla angiven på {count} verifikationer.',
  'inbox.uploadPaymentSingleTitle': 'Betalt från',
  'inbox.uploadPaymentBulkTitle': 'Fördela betalningskälla',
  'inbox.uploadPaymentAppliesTo': 'Gäller {count} valda verifikationer',
  'inbox.uploadPaymentSelectFirst': 'Markera verifikationerna nedan, så anger knapparna betalningskällan för dem.',
  'inbox.uploadPaymentBank': 'Bank',
  'inbox.uploadPaymentBankSetup': 'Lägg in bankkonto först',
  'inbox.uploadPaymentOtherSource': 'Välj annan betalningskälla ...',
  'inbox.uploadPaymentOperating': 'Driftskonto',
  'inbox.uploadPaymentPrivate': 'Privat',
  'inbox.uploadPaymentPrivateRecommended': 'Rekommenderas utan företagskonto',
  'inbox.uploadPaymentAnalyzeShort': 'Superplumma analyserar',
  'inbox.collectionNotice': 'Inkassokrav',
  'inbox.collectionNoticeTitle': 'Detta hör ihop med originalverifikationen',
  'inbox.collectionNoticeBody': 'Huvudfordran ska inte bokföras eller momsredovisas igen. Koppla kravet till originalverifikationen; ränta och indrivningskostnader behandlas separat utan moms.',
  'inbox.collectionNoticePrincipal': 'Huvudfordran',
  'inbox.collectionNoticeInterest': 'Ränta',
  'inbox.collectionNoticeCosts': 'Indrivningskostnader',
  'inbox.collectionNoticeCandidates': 'Möjliga originalverifikationer',
  'inbox.collectionNoticeLink': 'Koppla till',
  'inbox.collectionNoticeLinked': 'Inkassokravet har kopplats till originalverifikationen.',
  'inbox.collectionNoticeLinkFailed': 'Kunde inte koppla inkassokravet till originalverifikationen.',
  'inbox.collectionNoticeOpenOriginal': 'Öppna originalverifikationen',
  'inbox.collectionNoticeNoCandidate': 'Hittade inget säkert förslag. Hitta eller ladda upp originalfakturan innan kravet behandlas.',
  'inbox.collectionNoticeBookBlocked': 'Koppla till originalverifikationen före behandling',
  'inbox.uploadPaymentAssigned': 'Konto {account}',
  'inbox.uploadPaymentUnpaid': 'Inte betald än',
  'inbox.uploadPaymentUnpaidHint': 'För leverantörsfaktura som ska stå som skuld tills den betalas.',
  'inbox.uploadPaymentAnalyze': 'Låt Plumme hitta betalningskällan',
  'inbox.uploadPaymentUnassigned': 'Inte klarlagd',
  'inbox.uploadPaymentSelectVisible': 'Välj visade',
  'inbox.uploadPaymentShowAll': 'Visa alla',
  'inbox.uploadPaymentShowPending': 'Visa bara oklara',
  'inbox.uploadPaymentProgress': '{completed} av {count} klarlagda',
  'inbox.uploadPaymentConfirm': 'Ladda upp {count}',
  'inbox.uploadPaymentReceipt': 'Verifikation',
  'inbox.cardNudgeTitle': '{count} verifikationer saknar betalningskälla',
  'inbox.cardNudgeText': 'Registrera korten på bankkontona, så känner Plumme igen betalningen direkt från kvittot. Kontotypen avgör om inköpet blir företag eller privat utlägg.',
  'inbox.cardNudgeAction': 'Registrera kort',
  'inbox.shortDescription': 'Kort beskrivning av verifikationen',
  'inbox.shrinkPreview': 'Förminska förhandsvisning',
  'inbox.growPreview': 'Förstora förhandsvisning',
  'inbox.dragWidth': 'Dra för att ändra bredd',
  'inbox.sendTo': 'Skicka till:',
  'inbox.filterStatus': 'Status',
  'inbox.filterBankConnection': 'Bankkoppling',
  'inbox.filterReadyToPost': 'Klar för bokföring',
  'inbox.filterNeedsReview': 'Att kontrollera',
  'inbox.filterAwaitingAnalysis': 'Väntar på analys',
  'inbox.toInbox': 'Till inkorgen (verifikationer)',
  'inbox.toDocumentation': 'Till dokumentation',
  'inbox.selectAll': 'Välj alla',
  'inbox.selectHint': 'Skift-klicka för att välja flera i rad',
  'inbox.reviewSelected': 'Börja bokföra ({count})',
  'inbox.planTitle': 'Bokför med SuperPlumma',
  'inbox.planLead': '{count} av {selected} valda verifikationer bokförs nu.',
  'inbox.planNothing': 'Ingen av de valda verifikationerna kan bokföras som de ser ut nu.',
  'inbox.planWithNotes': '{count} med förvald betalningskälla',
  'inbox.planConfirm': 'Bokför {count} verifikationer',
  'inbox.planShow': 'Visa',
  'inbox.planHide': 'Dölj',
  'inbox.planSameFile': 'Spärrad: exakt samma fil finns redan ({count})',
  'inbox.planSameInvoiceNumber': 'Spärrad: fakturanumret är redan registrerat ({count})',
  'inbox.planSameContent': 'Hoppas över: möjlig dubbeluppladdning ({count})',
  'inbox.planNeedsReview': 'Hoppas över: behöver kontrolleras ({count})',
  'inbox.planMissingData': 'Hoppas över: saknar data ({count})',
  'inbox.planMissing': 'Hoppas över: finns inte längre ({count})',
  'inbox.planAllowContent': 'Bokför dessa ändå - jag har kontrollerat att det är olika inköp',
  'inbox.planAllowContentWarn': 'Dubbletterna bokförs som separata verifikationer. Kontrollera att det stämmer innan du fortsätter.',
  'inbox.planResultTitle': 'Bokföringen är klar',
  'inbox.planResultLead': '{booked} av {selected} valda verifikationer bokfördes.',
  'inbox.planBooked': 'Bokförda ({count})',
  'inbox.planSkipped': 'Överhoppade ({count})',
  'inbox.planFailed': 'Misslyckade ({count})',
  'inbox.walkTitle': 'Bokföring av verifikationer',
  'inbox.walkLead': '{count} verifikationer i kön.',
  'inbox.walkReady': 'Klara',
  'inbox.walkNeedsReview': 'Behöver kontrolleras',
  'inbox.walkDuplicates': 'Möjliga dubbletter',
  'inbox.walkDuplicateOf': 'Samma som {names}.',
  'inbox.walkHint': 'Du kan stänga när som helst - de du inte har hanterat förblir valda.',
  'inbox.walkStart': 'Gå igenom alla {count}',
  'inbox.walkBookReady': 'Bokför de {count} klara nu',
  'inbox.walkPosition': '{index} av {total}',
  'inbox.walkPause': 'Fortsätt senare',
  'inbox.walkTrash': 'Till papperskorgen',
  'inbox.walkSkip': 'Hoppa över',
  'inbox.walkNext': 'Nästa',
  'inbox.walkGone': 'Verifikationen är borta',
  'inbox.walkGoneText': 'Den bokfördes, togs bort eller flyttades medan genomgången var öppen.',
  'inbox.walkDoneTitle': 'Genomgången är klar',
  'inbox.walkDoneLead': '{count} verifikationer genomgångna',
  'inbox.walkDoneCounts': '{booked} bokförda, {skipped} överhoppade, {trashed} flyttade till papperskorgen.',
  'inbox.clearSelection': 'Rensa val',
  'inbox.restoreAll': 'Återställ alla',
  'inbox.deletePermanently': 'Ta bort permanent',
  'inbox.deleteAll': 'Ta bort alla',
  'inbox.downloadAll': 'Ladda ner valda',
  'inbox.downloading': 'Laddar ner...',
  'inbox.postAllWithAi': 'Bokför alla med SuperPlumma',
  'inbox.postWithAi': 'Bokför {count} med SuperPlumma',
  'inbox.postNoneReady': 'Ingen av de valda verifikationerna är klar för bokföring. Använd ”Starta bokföring” för att ta dem en i taget.',
  'inbox.uploadDocument': 'Ladda upp dokument',
  'inbox.mergeToOne': 'Slå ihop till en verifikation',
  'inbox.dragToMerge': 'Dra för att slå ihop verifikationer',
  'inbox.restore': 'Återställ',
  'inbox.post': 'Bokför',
  'inbox.archiveNote': 'Arkiv för dokument som inte ska bokföras som verifikationer.',
  'inbox.searchDocs': 'Sök i dokument...',
  'inbox.moveToTrash': 'Flytta till papperskorgen',
  'inbox.defaultVoucherName': 'Verifikation',
  'inbox.defaultDocumentName': 'Dokument',
  'inbox.docTypeSettlement': 'Avräkning',
  'inbox.docTypeSupplierInvoice': 'Leverantörsfaktura',
  'inbox.docTypeSaleVoucher': 'Försäljningsverifikation',
  'inbox.docTypePurchaseVoucher': 'Inköpsverifikation',
  'inbox.paySourcePrivate': 'Privat betald',
  'inbox.paySourceCash': 'Kontant',
  'inbox.paySourceUnclear': 'Oklar betalning',
  'inbox.paySourceCompany': 'Företagskonto',
  'inbox.vatOnDocumentWithDeduction': '{documentRate} % moms på verifikationen · {deductionRate} % avdrag',
  'inbox.vatRateLabel': '{rate} % moms',
  'inbox.paidFromBank': 'Betald från bank',
  'inbox.supplierNotRead': 'Företag inte avläst',
  'inbox.invoiceNumberLabel': 'Faktura {number}',
  'inbox.attachmentLinkMissing': 'Bilagan saknar tillgänglig länk.',
  'inbox.menuNewPurchase': 'Betalt köp',
  'inbox.menuFixedAsset': 'Inventarie',
  'inbox.menuOtherSale': 'Annan försäljning',
  'inbox.menuOpenAttachment': 'Öppna bilaga',
  'inbox.menuDownload': 'Ladda ner',
  'inbox.menuSplitAgain': 'Dela upp igen',
  'inbox.reanalyze': 'Analysera om',
  'inbox.analyze': 'Analysera',
  'inbox.previewDocumentFallback': 'Dokument',
  'inbox.previewMissingFileLink': 'Fillänk saknas',
  'inbox.saveNotConnected': 'Sparande av verifikationsförslag är inte kopplat till backend.',
  'inbox.suggestionUpdated': 'Verifikationsförslaget är uppdaterat.',
  'inbox.suggestionSaveFailed': 'Kunde inte spara verifikationsförslaget.',
  'inbox.settlementFromLabel': 'Avräkning från',
  'inbox.settlementFromPh': 'Vipps, Stripe, Klarna ...',
  'inbox.settlementIdLabel': 'Avräknings-ID',
  'inbox.settlementNetToBankLabel': 'Netto till bank',
  'inbox.suggestedInvoiceSingular': 'Föreslagen faktura',
  'inbox.suggestedInvoicePlural': 'Flera möjliga fakturor',
  'inbox.selectInvoiceManually': 'Välj faktura manuellt',
  'inbox.paidToggleOn': 'Betald',
  'inbox.paidToggleOff': 'Inte betald – förs som leverantörsskuld',
  'inbox.paidToLabel': 'Betald till',
  'inbox.projectSaveFailed': 'Kunde inte spara projektet.',
  'inbox.awaitingOcrData': 'Väntar på OCR-data',
  'inbox.showSuggestionAgain': 'Visa förslag igen',
  'inbox.maximizePreview': 'Maximera förhandsgranskning',
  'inbox.uploadPartialAnalyzing': '{done} av {total} verifikationer laddades upp. Analyserar de som kom in ...',
  'inbox.uploadedSingle': 'Verifikation uppladdad.',
  'inbox.uploadedMultipleAnalyzing': '{count} verifikationer uppladdade. Analyserar ...',
  'inbox.uploadFailedSingle': 'Kunde inte ladda upp verifikationen.',
  'inbox.uploadFailedMultiple': 'Kunde inte ladda upp verifikationerna.',
  'inbox.uploadFailedGeneric': 'Kunde inte ladda upp verifikationer.',
  'inbox.remainingAwaitingAnalysisSuffix': '{count} verifikationer står kvar som ”Väntar på analys”.',
  'inbox.uploadedButAnalysisFailedSingle': 'Verifikationen laddades upp, men analysen misslyckades.',
  'inbox.uploadedButAnalysisFailedMultiple': 'Verifikationerna laddades upp, men analysen misslyckades.',
  'inbox.partialAnalysisFailed': '{failed} av {total} verifikationer analyserades inte. Prova ”Analysera” på raden.',
  'inbox.documentAddedSingle': 'Dokument lagt i Dokumentation.',
  'inbox.documentAddedMultiple': 'Dokumenten är lagda i Dokumentation.',
  'inbox.documentUploadFailed': 'Kunde inte ladda upp dokument.',
  'inbox.analyzed': 'Verifikationen är analyserad.',
  'inbox.analyzeActionFailed': 'Verifikationsanalysen misslyckades.',
  'inbox.bookedNoneReason': 'Inga verifikationer bokfördes.',
  'inbox.bookedSummary': '{booked} bokförda, {skipped} överhoppade.',
  'inbox.bookedOne': 'Verifikationen är bokförd.',
  'inbox.bookedCount': '{count} verifikationer är bokförda.',
  'inbox.bookFailedFallback': 'Kunde inte bokföra verifikationerna.',
  'inbox.setPaymentSourceFailed': 'Kunde inte ange betalningskällan.',
  'inbox.moveToTrashFailed': 'Kunde inte flytta verifikation.',
  'inbox.movedToTrash': 'Verifikation flyttad till papperskorgen.',
  'inbox.movedToTrashCount': '{count} verifikationer flyttade till papperskorgen.',
  'inbox.restoredOne': 'Verifikation återställd.',
  'inbox.restoredCount': '{count} verifikationer återställda.',
  'inbox.restoreFailed': 'Kunde inte återställa verifikation.',
  'inbox.confirmDeletePermanentOne': 'Ta bort verifikationen permanent?',
  'inbox.confirmDeletePermanentMany': 'Ta bort valda verifikationer permanent?',
  'inbox.deletedPermanently': 'Verifikation borttagen permanent.',
  'inbox.deleteFailed': 'Kunde inte ta bort verifikation.',
  'inbox.docMovedToTrash': 'Dokument flyttat till papperskorgen.',
  'inbox.docMovedToTrashCount': '{count} dokument flyttade till papperskorgen.',
  'inbox.docMoveToTrashFailed': 'Kunde inte flytta dokument.',
  'inbox.docRestored': 'Dokument återställt.',
  'inbox.docRestoredCount': '{count} dokument återställda.',
  'inbox.docRestoreFailed': 'Kunde inte återställa dokument.',
  'inbox.confirmDeleteDocOne': 'Ta bort dokumentet permanent?',
  'inbox.confirmDeleteDocMany': 'Ta bort valda dokument permanent?',
  'inbox.docDeletedPermanently': 'Dokument borttaget permanent.',
  'inbox.docDeleteFailed': 'Kunde inte ta bort dokument.',
  'inbox.downloadPartial': '{downloaded} av {total} filer laddades ner. Resten kunde inte hämtas.',
  'inbox.downloadedZip': '{count} filer nedladdade som zip.',
  'inbox.downloadedSingleFile': 'Filen är nedladdad.',
  'inbox.downloadFilesFailed': 'Kunde inte ladda ner filerna.',
  'inbox.movedToDocs': 'Verifikation flyttad till Dokumentation.',
  'inbox.movedToDocsCount': '{count} verifikationer flyttade till Dokumentation.',
  'inbox.moveToDocsFailed': 'Kunde inte flytta verifikation till Dokumentation.',
  'inbox.mergedCount': '{count} verifikationer ihopslagna.',
  'inbox.mergeFailed': 'Kunde inte slå ihop verifikationer.',
  'inbox.splitAgainDone': 'Verifikationen är uppdelad igen.',
  'inbox.splitAgainFailed': 'Kunde inte dela upp verifikationen.',
  'inbox.addressCopied': 'Verifikationsadress kopierad.',
  'inbox.trashTitle': 'Papperskorg',
  'inbox.docsSubtitle': 'Arkiv för avtal, kontrakt och dokument - inte verifikationer för bokföring.',
  'inbox.inboxSubtitle': 'Ladda upp eller vidarebefordra verifikationer via e-post - vi läser av det vi kan.',
  'inbox.titleHelp': 'Inkorgen är samlingsplatsen för verifikationer som har kommit in men inte bokförts ännu. Ladda upp filer eller vidarebefordra kvitton och fakturor via e-post - SuperPlumma läser av innehållet och gör dem klara för bokföring.',
  'inbox.docsWithCount': 'Dokumentation ({count})',
  'inbox.trashWithCount': 'Papperskorg ({count})',
});
